/* Samedi storefront JS: AJAX add-to-cart, variant price, localStorage wishlist, promo */
(function () {
  var routes = window.routes || {};
  var cartAddUrl = routes.cart_add_url || '/cart/add';

  function money(cents) {
    return (cents / 100).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' }).replace(/\.00$/, '');
  }

  /* ---------- cart count badge ---------- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('a[aria-label="Cart"]').forEach(function (link) {
          var badge = link.querySelector('.cart-count');
          if (cart.item_count > 0) {
            if (!badge) { badge = document.createElement('span'); badge.className = 'cart-count'; link.appendChild(badge); }
            badge.textContent = cart.item_count;
          } else if (badge) { badge.remove(); }
        });
      });
  }

  /* ---------- AJAX add to cart (no navigation) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('#atc-form, .card-quick-form, .bcard-quick-form, .bcard-add-form')) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var original = btn ? btn.innerHTML : '';
    if (btn) btn.disabled = true;
    fetch(cartAddUrl, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) {
          btn.disabled = false;
          var isRound = btn.matches('.card-quick, .bcard-quick');
          if (res.ok && isRound) {
            btn.classList.add('added');
            btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
            setTimeout(function () { btn.classList.remove('added'); btn.innerHTML = original; }, 1700);
          } else {
            btn.innerHTML = res.ok ? 'Added ✓' : ((res.j && res.j.description) || 'Unavailable');
            setTimeout(function () { btn.innerHTML = original; }, 1700);
          }
        }
        if (res.ok) refreshCartCount();
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
  });

  /* ---------- PDP variant price ---------- */
  var variants = window.samediVariants;
  if (variants) {
    var priceEl = document.querySelector('[data-price]');
    var atcPriceEl = document.querySelector('[data-atc-price]');
    document.querySelectorAll('.pdp .sizes input[name=id]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var v = variants[radio.value];
        if (!v) return;
        if (priceEl) priceEl.textContent = v.price;
        if (atcPriceEl) atcPriceEl.textContent = v.priceShort;
      });
    });
  }

  /* ---------- Wishlist (localStorage) ---------- */
  var WKEY = 'samedi_wishlist';
  function wlGet() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function wlSet(a) { localStorage.setItem(WKEY, JSON.stringify(a)); }
  function wlHas(h) { return wlGet().indexOf(h) > -1; }
  function wlToggle(h) { var a = wlGet(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.push(h); wlSet(a); return a.indexOf(h) > -1; }

  function markHearts() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      b.classList.toggle('is-saved', wlHas(b.getAttribute('data-handle')));
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    var nowSaved = wlToggle(b.getAttribute('data-handle'));
    b.classList.toggle('is-saved', nowSaved);
    // On the wishlist page, un-saving removes the card
    var wlGridEl = document.querySelector('[data-wishlist-grid]');
    if (!nowSaved && wlGridEl) {
      var card = b.closest('.bcard, .card');
      if (card) card.remove();
      var emptyEl = document.querySelector('[data-wishlist-empty]');
      if (!wlGridEl.querySelector('.bcard, .card') && emptyEl) emptyEl.style.display = '';
    }
  });
  markHearts();

  /* ---------- Wishlist page render ---------- */
  var grid = document.querySelector('[data-wishlist-grid]');
  if (grid) {
    var handles = wlGet();
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!handles.length) { if (empty) empty.style.display = ''; }
    else {
      if (empty) empty.style.display = 'none';
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var heart = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 1 0-7.8 7.8l1 1.1L12 21.2l7.8-7.8 1-1.1a5.5 5.5 0 0 0 0-7.7z"/></svg>';
        var shield = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 2 4 6v6c0 5 3.5 8 8 10 4.5-2 8-5 8-10V6z"/><path d="m9 12 2 2 4-4"/></svg>';
        products.filter(Boolean).forEach(function (p) {
          var art = document.createElement('article');
          art.className = 'bcard';
          var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=800' : p.featured_image + '?width=800') : '';
          art.innerHTML =
            '<div class="bcard-media">' +
              '<button class="bcard-fav is-saved" type="button" data-wishlist-toggle data-handle="' + p.handle + '" aria-label="Remove from wishlist">' + heart + '</button>' +
              '<a href="/products/' + p.handle + '">' + (img ? '<img src="' + img + '" alt="' + p.title + '" loading="lazy">' : '') + '</a>' +
              '<span class="bcard-auth">' + shield + '925 · Hallmarked</span>' +
            '</div>' +
            '<div class="bcard-body">' +
              '<div class="bcard-top"><a href="/products/' + p.handle + '"><span class="bcard-name">' + p.title + '</span></a><span class="bcard-price">' + money(p.price) + '</span></div>' +
              '<div class="bcard-meta"><span class="bcard-price-m">' + money(p.price) + '</span></div>' +
              '<a href="/products/' + p.handle + '" class="bcard-add" style="display:block;text-align:center">View product</a>' +
            '</div>';
          grid.appendChild(art);
        });
      });
    }
  }

  /* ---------- Promo code -> Shopify discount session (carries to checkout) ---------- */
  var promo = document.querySelector('[data-promo-form]');
  if (promo) {
    var applyPromo = function () {
      var input = promo.querySelector('input');
      var code = input && input.value ? input.value.trim() : '';
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    };
    var pbtn = promo.querySelector('[data-promo-apply]');
    if (pbtn) pbtn.addEventListener('click', applyPromo);
    var pinput = promo.querySelector('input');
    if (pinput) pinput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyPromo(); } });
  }
  // Remove an applied discount code (clears the cart's discount session, then reloads)
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-promo-remove]');
    if (!rm) return;
    e.preventDefault();
    rm.disabled = true;
    fetch('/discount?discount=', { method: 'GET' })
      .catch(function () {})
      .then(function () {
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) }).catch(function () {});
      })
      .then(function () { window.location.href = '/cart'; });
  });

  /* ---------- Read-a-review modal (PDP review cards) ---------- */
  var rvrModal = document.getElementById('rvrModal');
  if (rvrModal) {
    var rvrStars = rvrModal.querySelector('[data-rvr-stars]');
    var rvrTitle = rvrModal.querySelector('[data-rvr-title]');
    var rvrQuote = rvrModal.querySelector('[data-rvr-quote]');
    var rvrName = rvrModal.querySelector('[data-rvr-name]');
    var rvrVerified = rvrModal.querySelector('[data-rvr-verified]');

    // Only offer "Read more" on cards whose text is actually cut off.
    var markClamped = function () {
      document.querySelectorAll('.rev .rev-body').forEach(function (body) {
        var card = body.closest('.rev');
        if (!card) return;
        card.classList.toggle('is-clamped', body.scrollHeight - body.clientHeight > 2);
      });
    };
    markClamped();
    window.addEventListener('resize', markClamped);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(markClamped);

    var closeRvr = function () {
      rvrModal.classList.remove('open');
      document.body.style.overflow = '';
    };

    document.addEventListener('click', function (e) {
      var card = e.target.closest('[data-rev-open]');
      if (card) {
        e.preventDefault();
        var n = parseInt(card.getAttribute('data-stars'), 10) || 5;
        if (rvrStars) rvrStars.textContent = '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
        var t = card.getAttribute('data-title') || '';
        if (rvrTitle) { rvrTitle.textContent = t; rvrTitle.hidden = !t; }
        if (rvrQuote) rvrQuote.textContent = card.getAttribute('data-quote') || '';
        if (rvrName) rvrName.textContent = card.getAttribute('data-name') || '';
        if (rvrVerified) rvrVerified.hidden = !card.getAttribute('data-verified');
        rvrModal.classList.add('open');
        document.body.style.overflow = 'hidden';
        return;
      }
      if (e.target.closest('[data-rev-close]')) closeRvr();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && rvrModal.classList.contains('open')) closeRvr();
    });
  }

  /* ---------- Review modal ---------- */
  var rvModal = document.getElementById('rvModal');
  if (rvModal) {
    var rvProductInput = document.getElementById('rvProduct');
    var rvProductLabel = rvModal.querySelector('[data-review-product]');
    var rvForm = document.getElementById('rvForm');
    var rvFormWrap = rvModal.querySelector('.rv-form-wrap');
    var rvThanks = rvModal.querySelector('.rv-thanks');
    var openReview = function (name, handle) {
      if (rvProductInput) rvProductInput.value = (name || '') + (handle ? ' (' + handle + ')' : '');
      if (rvProductLabel) rvProductLabel.textContent = name || 'this piece';
      if (rvFormWrap) rvFormWrap.style.display = '';
      if (rvThanks) rvThanks.style.display = 'none';
      rvModal.classList.add('open');
      document.body.style.overflow = 'hidden';
    };
    var closeReview = function () { rvModal.classList.remove('open'); document.body.style.overflow = ''; };
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-review-open]');
      if (opener) { e.preventDefault(); openReview(opener.getAttribute('data-product'), opener.getAttribute('data-handle')); return; }
      if (e.target.closest('[data-review-close]')) closeReview();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeReview(); });
    var rvStars = document.getElementById('rvStars');
    var rvRating = document.getElementById('rvRating');
    if (rvStars && rvRating) {
      rvStars.querySelectorAll('.rv-star').forEach(function (star) {
        star.addEventListener('click', function () {
          var v = +star.getAttribute('data-v');
          rvRating.value = v;
          rvStars.querySelectorAll('.rv-star').forEach(function (s) { s.classList.toggle('on', +s.getAttribute('data-v') <= v); });
        });
      });
    }
    if (rvForm) {
      rvForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var sbtn = rvForm.querySelector('[type=submit]');
        if (sbtn) sbtn.disabled = true;
        fetch(rvForm.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(rvForm) })
          .catch(function () {})
          .then(function () {
            if (rvFormWrap) rvFormWrap.style.display = 'none';
            if (rvThanks) rvThanks.style.display = 'block';
          });
      });
    }
  }
})();
